module.exports = {"130506100":"和阳镇","130506101":"贾宋镇","130506102":"郝桥镇","130506103":"三思镇","130506104":"河郭镇","130506200":"东三召乡","130506201":"阎里乡","130506203":"史召乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130506.json
// module id = 220
// module chunks = 0